<template>
    <div class="tuike">
        <header1></header1>
        <div class="main-tuike">
            <div class="nav-bg">
                <div class="nav-banner">
                    <div class="banner-box">
                        <div class="left">
                            <div class="title">专区速搭平台</div>
                            <div class="title">页面搭建解决方案</div>
                            <p class="sub-title">
                                提供海量的专区模板、丰富的复杂功能组件，可以自由拖拽操作
                                搭建专区，后续维护便利、页面数据清晰
                                即使不懂代码，也能快速搭建一个你想要的精美页面专区
                            </p>
                            <div>
                                <a @click="denglu" class="btn">立即试用</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap mt100">
                <div class="dom-item">
                    <div class="dom-title">颠覆传统开发模式</div>
                    <div class="dom-content mt60 flex">
                        <div class="box">
                            <div class="box-h">
                                <div class="num">01</div>
                                <div class="titles">
                                    <div class="title-h1">一键生成H5页</div>
                                    <div class="title-h2">
                                        效果即改即显、实时感知
                                    </div>
                                </div>
                            </div>
                            <div class="box-b">
                                <div class="vs">VS</div>
                                <div class="title">传统模式</div>
                                <div class="txt">
                                    <span class="dot"></span
                                    ><span class="desc">开发耗时长</span>
                                </div>
                                <div class="txt">
                                    <span class="dot"></span
                                    ><span class="desc">开发任务重复</span>
                                </div>
                                <div class="txt">
                                    <span class="dot"></span
                                    ><span class="desc"
                                        >不断与技术人员沟通</span
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="box">
                            <div class="box-h">
                                <div class="num">02</div>
                                <div class="titles">
                                    <div class="title-h1">海量模板</div>
                                    <div class="title-h2">
                                        营销场景下的专业模板
                                    </div>
                                </div>
                            </div>
                            <div class="box-b">
                                <div class="vs">VS</div>
                                <div class="title">传统模式</div>
                                <div class="txt">
                                    <span class="dot"></span
                                    ><span class="desc">页面风格单一</span>
                                </div>
                                <div class="txt">
                                    <span class="dot"></span
                                    ><span class="desc">设计固定</span>
                                </div>
                                <div class="txt">
                                    <span class="dot"></span
                                    ><span class="desc">制作耗时长</span>
                                </div>
                            </div>
                        </div>
                        <div class="box">
                            <div class="box-h">
                                <div class="num">03</div>
                                <div class="titles">
                                    <div class="title-h1">维护便捷</div>
                                    <div class="title-h2">
                                        无需部署，一键发布
                                    </div>
                                </div>
                            </div>
                            <div class="box-b">
                                <div class="vs">VS</div>
                                <div class="title">传统模式</div>
                                <div class="txt">
                                    <span class="dot"></span
                                    ><span class="desc">内容修改繁琐</span>
                                </div>
                                <div class="txt">
                                    <span class="dot"></span
                                    ><span class="desc">需要再次开发</span>
                                </div>
                                <div class="txt">
                                    <span class="dot"></span
                                    ><span class="desc">维护二次收费</span>
                                </div>
                            </div>
                        </div>
                        <div class="box">
                            <div class="box-h">
                                <div class="num">04</div>
                                <div class="titles">
                                    <div class="title-h1">数据采集</div>
                                    <div class="title-h2">
                                        让数据支撑优化决策
                                    </div>
                                </div>
                            </div>
                            <div class="box-b">
                                <div class="vs">VS</div>
                                <div class="title">传统模式</div>
                                <div class="txt">
                                    <span class="dot"></span
                                    ><span class="desc">数据采集少</span>
                                </div>
                                <div class="txt">
                                    <span class="dot"></span
                                    ><span class="desc">业务进展无考量</span>
                                </div>
                                <div class="txt">
                                    <span class="dot"></span
                                    ><span class="desc">决策无依据</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap mt100">
                <div class="dom-item">
                    <div class="dom-title">页面制作从未如此简单</div>
                    <div class="dom-subtitle">5分钟搭建一个美观的页面</div>
                    <div class="dom-content">
                        <div class="pitem">
                            <div class="circle">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/cube/icon_1.png"
                                    alt=""
                                    class="icon"
                                /><img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/cube/icon_bg.png"
                                    alt=""
                                    class="icon_bg"
                                />
                            </div>
                            <div class="ptxt">挑选模板</div>
                        </div>
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/cube/r-arrow.png"
                            class="r-arrow"
                        />
                        <div class="pitem">
                            <div class="circle">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/cube/icon_2.png"
                                    alt=""
                                    class="icon"
                                /><img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/cube/icon_bg.png"
                                    alt=""
                                    class="icon_bg"
                                />
                            </div>
                            <div class="ptxt">拖拽式配置</div>
                        </div>
                        <img
                            src="https://ccbhdimg.kerlala.com/hd/website/urthink/cube/r-arrow.png"
                            class="r-arrow"
                        />
                        <div class="pitem">
                            <div class="circle">
                                <img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/cube/icon_3.png"
                                    alt=""
                                    class="icon"
                                /><img
                                    src="https://ccbhdimg.kerlala.com/hd/website/urthink/cube/icon_bg.png"
                                    alt=""
                                    class="icon_bg"
                                />
                            </div>
                            <div class="ptxt">多渠道投放</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap mt120">
                <div class="dom-item">
                    <div class="dom-content">
                        <div class="p2_item">
                            <div class="p2_item_title">多场景精美模板</div>
                            <div class="p2_item_desc">
                                针对不同营销场景，提供海量素材、专业模板
                            </div>
                        </div>
                        <div class="p2_item">
                            <div class="p2_item_title">丰富功能模块</div>
                            <div class="p2_item_desc">
                                轮播图、导航、活动专题、弹窗...<br />
                                享有各类功能，性价比高，定期持续更新
                            </div>
                        </div>
                        <div class="p2_item">
                            <div class="p2_item_title">样式高度自定义</div>
                            <div class="p2_item_desc">页面效果由你决定</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap mt120">
                <div class="dom-item">
                    <div class="dom-content">
                        <div class="dom-tab">
                            <div class="tab">
                                <div
                                    class="tab_item"
                                    :class="item.active_no ? 'on' : ''"
                                    v-for="(item, index) in tabs"
                                    :key="index"
                                    @click="activeTabs(index)"
                                >
                                    页面编辑器
                                </div>
                            </div>
                            <div class="tab_content">
                                <div
                                    class="tab_content_item"
                                    v-if="tab_content_s == 0"
                                >
                                    <div class="mr60">
                                        <div class="content_item_title">
                                            最简单的页面编辑器
                                        </div>
                                        <div class="content_item_subtitle">
                                            <span class="gou"></span>
                                            <span class="gou-txt"
                                                >一拖一拽，自由操作，即可搭建页面</span
                                            >
                                        </div>
                                        <div class="content_item_subdesc">
                                            不需要任何技术或设计的背景
                                        </div>
                                        <div class="content_item_subtitle">
                                            <span class="gou"></span>
                                            <span class="gou-txt"
                                                >页面效果实时感知</span
                                            >
                                        </div>
                                        <div class="content_item_subdesc">
                                            即改即显、完成后立即上线
                                        </div>
                                    </div>
                                    <img
                                        src="https://ccbhdimg.kerlala.com/hd/website/urthink/cube/part_1.png"
                                    />
                                </div>
                                <div
                                    class="tab_content_item flex-reverse"
                                    v-if="tab_content_s == 1"
                                >
                                    <div>
                                        <div class="content_item_title">
                                            即刻开启精细化运营
                                        </div>
                                        <div class="content_item_subtitle">
                                            <span class="gou"></span>
                                            <span class="gou-txt"
                                                >客户分群运营</span
                                            >
                                        </div>
                                        <div class="content_item_subdesc">
                                            使用场景丰富，满足不同客群所需<br />客户精细化运营，千人千面
                                        </div>
                                        <div class="content_item_subtitle">
                                            <span class="gou"></span>
                                            <span class="gou-txt"
                                                >页面分渠道展示</span
                                            >
                                        </div>
                                        <div class="content_item_subdesc">
                                            活动内容分渠道展示 提高运营效率
                                        </div>
                                    </div>
                                    <img
                                        src="https://ccbhdimg.kerlala.com/hd/website/urthink/cube/part_2.png"
                                        alt=""
                                        class="mr60"
                                    />
                                </div>
                                <div
                                    class="tab_content_item"
                                    v-if="tab_content_s == 2"
                                >
                                    <div class="mr60">
                                        <div class="content_item_title">
                                            专区优化有据可依
                                        </div>
                                        <div class="content_item_subtitle">
                                            <span class="gou"></span>
                                            <span class="gou-txt"
                                                >精细化的数据统计</span
                                            >
                                        </div>
                                        <div class="content_item_subdesc">
                                            页面流量、渠道统计、功能统计、用户行为数据统计等
                                        </div>
                                        <div class="content_item_subtitle">
                                            <span class="gou"></span>
                                            <span class="gou-txt"
                                                >多维度数据采集</span
                                            >
                                        </div>
                                        <div class="content_item_subdesc">
                                            让数据驱动增长
                                        </div>
                                    </div>
                                    <img
                                        src="https://ccbhdimg.kerlala.com/hd/website/urthink/cube/part_1.png"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dom-wrap dom-type-1">
                <div class="dom-item">
                    <div class="dom-title">他们都在用专区速搭</div>
                    <div class="dom-content mt60">
                        <div class="p4_item">
                            <div class="p4_item_h">中国建设银行</div>
                            <div class="p4_item_b">
                                <div class="p4_item_title">
                                    建行财富小镇分会场
                                </div>
                                <div class="p4_item_underline"></div>
                                <div class="p4_item_desc">
                                    各个业务线分会场、保险分<br />
                                    杨月会场、贵金厘分会场、存款分会场、基金分会场
                                </div>
                            </div>
                        </div>
                        <div class="p4_item">
                            <div class="p4_item_h">中信银行</div>
                            <div class="p4_item_b d3">
                                <div class="p4_item_title">
                                    中信广州分行专区
                                </div>
                                <div class="p4_item_underline"></div>
                                <div class="p4_item_desc">
                                    广州分行活动整合专区，展示奥运抢红包活动<br />
                                    龙抬头播种季等
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom">
            <more :moreid="id"></more>
            <info></info>
        </div>
    </div>
</template>

<script>
import header1 from "../../components/header1.vue";
import more from "../../components/more.vue";
import info from "../../components/info.vue";
export default {
    data() {
        return {
            tabs: [
                { name: "页面编辑器", active_no: true },
                { name: "精细化运营", active_no: false },
                { name: "数据驱动", active_no: false },
            ],
            tab_content_s: 0,
            id: 5,
        };
    },
    components: { header1, more, info },
    mounted() {
        var that = this;
        // this.common.mounted(that);
    },
    computed: {},
    methods: {
        nolond() {},
        activeTabs(index) {
            var tab = this.tabs;
            tab.forEach((item, val) => {
                if (index == val) {
                    item.active_no = true;
                } else {
                    item.active_no = false;
                }
            });
            this.tab_content_s = index;
        },
        denglu() {
            this.$router.push({
                path: "/login",
            });
        },
    },
};
</script>
<style scoped>
@import "../../../static/chunk-cube.css";
</style>


// WEBPACK FOOTER //
// src/views/slg/cube.vue